/* import __COLOCATED_TEMPLATE__ from './base.hbs'; */
import Component from '@glimmer/component';
import bbFrontendGlyphIconToSvg from '@banking/ui/utils/bb-frontend-glyph-icon-to-svg';
export default class DoMoreCard extends Component {
  get printableCheckIcon() {
    return bbFrontendGlyphIconToSvg(this.args.printableCheckAccessConfiguration.icon);
  }
}